import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { Box, Card, CircularProgress, Stack, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/LockOutlined';
import Services from 'src/services/Services';
import { tokenService } from 'src/services';

const getCurrentMallID = () => localStorage.getItem('mallID') || '';

export default function BlockedStoreList() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const mallID = getCurrentMallID();
    if (!mallID) {
      setStores([]);
      return;
    }

    const token = tokenService.getUser()?.token;

    setLoading(true);
    Services.GetStores(token, mallID)
      .then((res) => {
        const result = Array.isArray(res?.data?.result) ? res.data.result : [];
        setStores(result.filter((store) => String(store.isBlocked) === '1'));
      })
      .catch(() => setStores([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title> Blokajlı Mağaza Listesi </title>
      </Helmet>

      <Box sx={{ p: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
          Blokajlı Mağaza Listesi
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
          {stores.length} mağazanın taşıma işlemi askıya alınmıştır.
        </Typography>

        <Card>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
              <CircularProgress />
            </Box>
          ) : stores.length === 0 ? (
            <Box sx={{ py: 5, textAlign: 'center' }}>
              <Typography sx={{ color: 'text.secondary' }}>
                Blokajlı mağaza bulunmamaktadır.
              </Typography>
            </Box>
          ) : (
            stores.map((store, index) => (
              <Stack
                key={store.branchID || store.id || index}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  px: 3,
                  py: 2,
                  borderBottom:
                    index === stores.length - 1 ? 'none' : '1px solid #F0F0F0',
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      backgroundColor: 'error.lighter',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <LockIcon sx={{ color: 'error.main', fontSize: 20 }} />
                  </Box>
                  <Typography sx={{ fontWeight: 700 }}>
                    {(store.title || '-').toLocaleUpperCase('tr-TR')}
                  </Typography>
                </Stack>

                <Box
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    borderRadius: '999px',
                    backgroundColor: 'error.lighter',
                    color: 'error.dark',
                    fontSize: 12,
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                  }}
                >
                  Blokajlı
                </Box>
              </Stack>
            ))
          )}
        </Card>
      </Box>
    </>
  );
}
